import { combineReducers } from 'redux';

import { animal } from './animal.reducer';
import { authentication } from './auth.reducer';
import { banner } from './banner.reducer';
import { cidade } from './cidade.reducer';
import { empresa } from './empresa.reducer';
import { estado } from './estado.reducer';
import { fazenda } from './fazenda.reducer';
import { fazendaCertificado } from './fazendaCertificado.reducer';
import { fazendaIntegracao } from './fazendaIntegracao.reducer';
import { home } from './home.reducer';
import { convenio } from './convenio.reducer';
import { log } from './log.reducer';
import { logErroGeral } from './logErroGeral.reducer';
import { logErroChaveNfe } from './logErroChaveNfe.reducer';
import { logFazendaSinc } from './logFazendaSinc.reducer';
import { logFazendaFinanceiroSinc } from './logFazendaFinanceiroSinc.reducer';
import { motivoDesistencia } from './motivoDesistencia.reducer';
import { parto } from './parto.reducer';
import { prefeitura } from './prefeitura.reducer';
import { produtor } from './produtor.reducer';
import { tanque } from './tanque.reducer';
import { termoUso } from './termoUso.reducer';
import { touro } from './touro.reducer';
import { usuario } from './usuario.reducer';
import { relatorio } from './relatorio.reducer';
import { visita } from './visita.reducer';
import { usuarioDispositivo } from './usuarioDispositivo.reducer';
import { versaoSistema } from './versaoSistema.reducer';

const rootReducer = combineReducers({
    animal,
    authentication,
    banner,
    empresa,
    estado,
    cidade,
    home,
    fazenda,
    fazendaCertificado,
    fazendaIntegracao,
    convenio,
    log,
    logErroGeral,
    logErroChaveNfe,
    logFazendaSinc,
    logFazendaFinanceiroSinc,
    motivoDesistencia,
    parto,
    produtor,
    prefeitura,
    tanque,
    termoUso,
    touro,
    usuario,
    relatorio,
    visita,
    usuarioDispositivo,
    versaoSistema
});

export default rootReducer;